<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <BRow
      class="gap-y-2 px-2"
    >
      <BCol
        cols="12"
        class="px-1"
      >
        <div
          class="card card-body p-3 rounded-lg mt-2"
        >
          <div class="d-flex flex-column flex-md-row align-items-md-center gap-5">
            <div class="flex-grow-1">
              <div class="h5">
                Good {{ greetings }}, <b class="text-primary">{{ currentUser?.name || 'Officer' }}</b>
              </div>
              <div>
                Your performance summary this month
              </div>
            </div>
            <div>
              <BFormGroup
                label="Month"
                label-for="filterMonth"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <flat-pickr
                  id="filterMonth"
                  v-model="gridTasks.filter.schedule"
                  class="form-control"
                  placeholder="--------- ----"
                  :config="flatPickerConfig"
                />
              </BFormGroup>
            </div>
          </div>
        </div>
      </BCol>
    </BRow>
    <!--
    <DashboardTasks
      ref="taskDashboard"
      class="mt-2"
    /> -->

    <!-- <DashboardUpcomingEvents
      ref="upcomingEventDashboard"
      class="mt-2"
      :loading="gridTasks.busy"
      :schedule="gridTasks.filter.schedule"
      :events="statistics.upcoming_events"
    /> -->

    <DashboardCustomerMemos
      ref="custmerMemoDashboard"
      :busy="gridTasks.busy"
      :schedule="gridTasks.filter.schedule"
      :customer-memos="statistics.customer_memos"
    />

    <DashboardActivities
      ref="activityDashboard"
      class="mt-2"
      :busy="gridTasks.busy"
      :schedule="gridTasks.filter.schedule"
      :activities="statistics.activities"
    />
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import createDate from 'moment'
import FPMonthSelect from 'flatpickr/dist/plugins/monthSelect'

import DashboardCustomerMemos from '@/views/fso/dashboards/DashboardCustomerMemos.vue'
import DashboardActivities from '@/views/fso/dashboards/DashboardActivities.vue'
// import DashboardTasks from '@/views/fso/dashboards/DashboardTasks.vue'
// import DashboardUpcomingEvents from '@/views/fso/dashboards/DashboardUpcomingEvents.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MxImageUrl from '@/mixins/image-url'
import MActivities from '@/mixins/maintenances/activities'
import MCustomers from '@/mixins/accounts/customers'

import { SFSODashboard } from '@/services/fso'

export default {

  name: 'FSODashboard',

  components: {
    DashboardCustomerMemos,
    DashboardActivities
    // DashboardTasks,
    // DashboardUpcomingEvents
  },

  mixins: [
    MxMisc,
    MxFormatter,
    MxImageUrl,
    MActivities,
    MCustomers
  ],

  middleware: ['auth', 'fso'],

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      flatPickerConfig: {
        appendTo: document.body,
        altInput: true,
        allowInput: true,
        disableMobile: true,
        plugins: [
          new FPMonthSelect({
            dateFormat: 'Y-m',
            altFormat: 'F Y'
          })
        ]
      },
      state: {
        busy: false,
        editing: false
      },
      statistics: {
        business_agreements: {
          closed: 0,
          count: 0,
          invalid: 0,
          valid: 0
        },
        customer_memos: [],
        activities: [],
        upcoming_events: [],
        customers: {
          new: 0,
          verified: 0
        },
        sales: {
          total: 0,
          current: 0
        }
      },
      gridTasks: {
        busy: false,
        filter: {
          search: '',
          schedule: createDate().format('YYYY-MM')
        },
        filterOn: [],
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        rows: []
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    greetings () {
      const currentHourOfTheDay = createDate().hour()

      if (currentHourOfTheDay >= 3 && currentHourOfTheDay < 12) {
        return 'Morning'
      } else if (currentHourOfTheDay === 12) {
        return 'Noon'
      } else if (currentHourOfTheDay > 12 && currentHourOfTheDay < 18) {
        return 'Afternoon'
      } else if (currentHourOfTheDay >= 18 && currentHourOfTheDay < 20) {
        return 'Evening'
      } else {
        return 'Night'
      }
    }
  },

  watch: {
    'gridTasks.filter.schedule' (schedule) {
      if (!schedule) {
        this.gridTasks.filter.schedule = createDate().format('YYYY-MM')
      } else {
        this.gridProvider()
        // this.$refs.taskDashboard.gridProvider(schedule)
      }
    }
  },

  mounted () {
    if (this.currentUser) {
      this.gridProvider()
    }
  },

  methods: {

    async gridProvider () {
      this.gridTasks.busy = true

      const schedule = String(this.gridTasks.filter.schedule || '').split('-')
      const month = schedule.length > 1 ? Number(schedule[1]) : ''
      const year = schedule.length > 0 ? schedule[0] : ''

      const payload = {
        schedule: this.gridTasks.filter.schedule,
        month,
        year
      }

      return SFSODashboard.getTotalCustomers(payload).then(
        ({ data }) => {
          this.statistics.customers = Object.assign(this.statistics.customers, {
            new: data.created_count,
            verified: data.verified_count
          })

          const upcomingEvents = {}

          Array.from(data.upcoming_events || []).forEach(upcomingEvent => {
            if (Object.keys(upcomingEvents).includes(upcomingEvent.event_date)) {
              upcomingEvents[upcomingEvent.event_date].push(upcomingEvent)
            } else {
              upcomingEvents[upcomingEvent.event_date] = [upcomingEvent]
            }
          })

          this.statistics.upcoming_events = upcomingEvents

          this.statistics.activities = data.other_events || []

          this.statistics.customer_memos = data.customer_memos || []
        }
      ).catch(() => {
        this.statistics.customers = Object.assign(this.statistics.customers, {
          new: 0,
          verified: 0
        })

        this.statistics.customer_memos = []
        this.statistics.upcoming_events = []
        this.statistics.activities = []
      }).finally(() => {
        this.gridTasks.busy = false
      })
    }
  }
}
</script>
